define ['./pay.css'], () ->
  (RentappService, $rootScope, $scope, $stateParams, $http, $state, RENTAPPLICATION_API_URL, Application, $cacheFactory, Flash, $location, $anchorScroll, Raven) ->
    application = Application.get id: $stateParams.application_id
    application.$promise.then (application_data) ->
      if application_data.status == "S" and application_data.price and application_data.is_paid
        $state.go "root.applications.apply_success", {application_id: application_data.id, application: application_data}
      $scope.sales_tax_amount = parseFloat(application_data.sales_tax_amount) or 0
      $scope.total_price = (parseFloat(application_data.price) or 0) + $scope.sales_tax_amount

    $scope.application = application

    $scope.card = {}

    $scope.submit_payment = () ->
      $scope.submitting_payment = true
      $scope.payment_receipt = $scope.card.payment_receipt
      #delete $scope.card.payment_receipt

      RentappService.getStripe().then((stripe) ->
        stripe.createToken($scope.card)
          .then((result) ->
            if result.error
              #Inform the user if there was an error.
              $rootScope.$broadcast("card-error", result.error)
              $scope.$apply () ->
                $scope.submitting_payment = false
            else 
              # Send the token to your server.
              token = result.token
              $http.post "#{RENTAPPLICATION_API_URL}/api/v1/application/#{$stateParams.application_id}/pay/",
                stripeToken: token.id
                payment_receipt: $scope.card.payment_receipt
              .then (response) ->
                $scope.submitting_payment = false
                $cacheFactory.get('$http').removeAll()

                $state.go "root.applications.apply_success",
                  paid: true
                  application_id: response.data.id
                  application: response.data
              .catch (error) ->
                Raven.captureMessage("submit-error", {
                  level: 'warning',
                  extra: error
                })
                $rootScope.$broadcast("submit-error", {
                  action: "pay"
                  app_id: $stateParams.application_id
                  response: error
                })
                Flash.create('danger', error.data.message, 0)
                $scope.submitting_payment = false
          )
      )



// WEBPACK FOOTER //
// ./components/applications/pay/pay.coffee